export enum QueryKey {
    maimFloor = 'maim-floor',
    listFloor = 'maim-floor-list',
    storeSetting = 'store-setting',
    listRoom = 'list-room',
}
